// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CUnmanagedResourceActivityBase_abstract } from './../abstract/SagaSchema/CUnmanagedResourceActivityBase_abstract';
export class CUnmanagedResourceActivityBase extends CUnmanagedResourceActivityBase_abstract {}
